var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCarat = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m21.63 7.23-1.06-1.06a1.24 1.24 0 0 0-1.76 0l-6.9 6.89L5 6.17a1.25 1.25 0 0 0-1.77 0L2.19 7.23a1.24 1.24 0 0 0 0 1.77L10 16.77l1 1.06a1.25 1.25 0 0 0 1.77 0l1.06-1.06L21.63 9a1.24 1.24 0 0 0 0-1.77Z"
})));
export default SvgCarat;